// src/pages/NewsStoryPage.jsx
import React from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { latestNews } from '../data/dummyData';
import './NewsStoryPage.css';

const NewsStoryPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const news = location.state?.news || latestNews.find(n => n.id === parseInt(id));

  if (!news) {
    return (
      <div className="news-not-found">
        <h2>News Story Not Found</h2>
        <p>The requested news article could not be found.</p>
        <Link to="/" className="back-to-home">← Back to Home</Link>
      </div>
    );
  }

  return (
    <div className="news-story-page">
      <div className="news-story-container">
        <article className="news-article">
          {/* 1. Hero Section (Title, Category, Date) */}
          <header className="article-header">
            {/* REMOVED: category badge */}
            <h1 className="article-title">{news.title}</h1>
            <div className="article-meta">
              <time dateTime={news.date} className="article-date">
                {new Date(news.date).toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </time>
              <span className="article-read-time">• 5 min read</span>
            </div>
          </header>

          {/* 2. Excerpt (as plain text) */}
          <div className="article-excerpt-section">
            <p className="article-excerpt">{news.excerpt}</p>
          </div>

          {/* 3. News Image */}
          <div className="article-image-section">
            <img src={news.image} alt={news.title} className="article-image" />
          </div>

          {/* 4. Article Content */}
          <div className="article-content">
            <div className="article-body">
              {news.fullContent.split('\n\n').map((paragraph, index) => (
                <p key={index} className="article-paragraph">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="article-navigation">
            <Link to="/" className="back-to-home">
              ← Back to Home
            </Link>
          </div>
        </article>
      </div>
    </div>
  );
};

export default NewsStoryPage;